export const APP_LANGUAGE_STORAGE_KEY = "smartcfo:preferredLanguage";

export const APP_LANGUAGES = [
  { code: "es", labelKey: "userMenu.languageEs", flag: "🇪🇸" },
  { code: "en", labelKey: "userMenu.languageEn", flag: "🇬🇧" },
];

const JAPANESE_LANGUAGE = {
  code: "ja",
  labelKey: "userMenu.languageJa",
  flag: "🇯🇵",
};

/**
 * El japonés está en desarrollo, así que el selector solo lo ofrece a estas
 * cuentas. Es un filtro de UI, no un control de acceso: `isAppLanguage` sigue
 * aceptando "ja" para que una preferencia ya guardada se respete.
 */
export const JAPANESE_LANGUAGE_ALLOWED_EMAILS = [
  "dieter.spee@smartcfo.cl",
  "nicolas.pacheco@smartcfo.cl",
  "joaquin.vila@smartcfo.cl",
  "daniela.gonzalez@smartcfo.cl",
];

export const canUseJapaneseLanguage = (email) =>
  JAPANESE_LANGUAGE_ALLOWED_EMAILS.includes(
    String(email || "").trim().toLowerCase(),
  );

/** Idiomas que se le muestran a este usuario en el selector. */
export const getAppLanguagesForUser = (email) =>
  canUseJapaneseLanguage(email)
    ? [...APP_LANGUAGES, JAPANESE_LANGUAGE]
    : APP_LANGUAGES;

export const isAppLanguage = (value) =>
  value === "es" || value === "en" || value === "ja";

export const readStoredAppLanguage = () => {
  try {
    const stored = localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
    return isAppLanguage(stored) ? stored : "es";
  } catch {
    return "es";
  }
};

export const writeStoredAppLanguage = (language) => {
  if (!isAppLanguage(language)) return;
  localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, language);
};
